import i18n from '~/localization/i18n';
import Router from '~/router';

class LocalizationManager {
    static changeLocale(locale: string) {
        window.location.href = `/${locale}${Router.currentRoute.fullPath}`;
    }

    static getLocale() {
        return i18n.locale;
    }
}

export default LocalizationManager;
